import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-create-dialog',
  templateUrl: './create-dialog.component.html',
  styleUrls: ['./create-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, AngularSvgIconModule, MatButtonModule, NgClass],
})
export class CreateDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      componentName: string;
      isMobile: boolean;
    }
  ) {}

  ngOnInit(): void {}

  dialogTitle(): string {
    return `Component ${this.data.componentName} created`;
  }

  isMobile(): boolean {
    return this.data.isMobile;
  }
}
